"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHotelContract = exports.addHotelContract = exports.getHotelContracts = exports.getProductRateById = exports.updateProductRates = exports.deleteRate = exports.addRates = exports.deleteProduct = exports.deleteContract = exports.addProduct = exports.updateProduct = exports.deleteContractComment = exports.addContractComment = exports.getContractComments = exports.updateHotel = exports.updateHotels = exports.getHotel = exports.addHotel = exports.getHotelsByRegionId = exports.getPublishedHotelsByRegionId = exports.getHotels = void 0;
const dayjs = require("dayjs");
const _ = require("lodash");
const getHotels = async (supabase) => {
    const { data: hotels, error } = await supabase
        .from("hotels")
        .select(`id, name, published, star_rating, slug, packages,  
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
      contracts:hotel_contracts(*, 
        supplier:supplier_id (id, name, currency), products:hotel_contract_products(*, rates:hotel_contract_product_rates(*))),
      hotel_rooms(*)`)
        .order("name->en", { ascending: true });
    if (!error)
        return hotels.map((hotel) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(hotel.contracts, (c) => {
                return c.end_date;
            });
            return {
                id: hotel.id,
                rooms: hotel.hotel_rooms,
                name: hotel.name,
                packages: hotel.packages,
                contracts: hotel.contracts,
                contract_expiry_date: latestContract?.end_date,
                star_rating: hotel.star_rating,
                published: hotel.published,
                slug: hotel.slug,
                region: {
                    id: hotel?.region?.id,
                    name: hotel?.region?.name,
                    slug: hotel?.region?.slug,
                },
                country: {
                    id: hotel?.region?.country?.id,
                    name: hotel?.region?.country?.name,
                    slug: hotel?.region?.country?.slug,
                },
            };
        });
    return error;
};
exports.getHotels = getHotels;
const getPublishedHotelsByRegionId = async (supabase, region_id) => {
    const { data: hotels, error } = await supabase
        .from("hotels")
        .select(`id, name, longitude, latitude, full_address, published, star_rating, review_score, number_of_reviews, hotel_type, is_recommended, is_luxury, summary, short_desc, description, facilities, slug, packages, images, transfer_area_id, policies,
      area:areas!area_id(*),
      transfer_area:areas!transfer_area_id(*),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
      contracts:hotel_contracts(*, 
        blackout_dates:hotel_contract_blackout_dates(*),
        supplier:supplier_id (id, name, currency), products:hotel_contract_products(*, rates:hotel_contract_product_rates(*))),
      hotel_rooms(*)`)
        .eq("region_id", region_id)
        .eq("published", true)
        .order("name->en", { ascending: true });
    if (!error)
        return hotels.map((hotel) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(hotel.contracts, (c) => {
                return c.end_date;
            });
            const contracts = hotel.contracts.map((contract) => {
                return {
                    ...contract,
                    blackout_dates: contract.blackout_dates,
                    products: contract.products.map((product) => {
                        return {
                            ...product,
                            hotel_room: hotel.hotel_rooms.find((room) => room.id === product.hotel_room_id),
                            rates: product.rates.map((rate) => {
                                return {
                                    ...rate,
                                };
                            }),
                        };
                    }),
                };
            });
            return {
                id: hotel.id,
                full_address: hotel.full_address,
                longitude: hotel.longitude,
                latitude: hotel.latitude,
                rooms: hotel.hotel_rooms,
                review_score: hotel.review_score,
                number_of_reviews: hotel.number_of_reviews,
                hotel_type: hotel.hotel_type,
                summary: hotel.summary,
                description: hotel.description,
                short_desc: hotel.short_desc,
                facilities: hotel.facilities,
                is_recommended: hotel.is_recommended,
                is_luxury: hotel.is_luxury,
                name: hotel.name,
                policies: hotel.policies,
                images: JSON.parse(hotel.images),
                packages: hotel.packages,
                contracts: contracts,
                contract_expiry_date: latestContract?.end_date,
                star_rating: hotel.star_rating,
                published: hotel.published,
                slug: hotel.slug,
                transfer_area: {
                    id: hotel?.transfer_area?.id,
                    name: hotel?.transfer_area?.name,
                    short_desc: hotel?.transfer_area?.short_desc,
                },
                area: {
                    id: hotel?.area?.id,
                    name: hotel?.area?.name,
                    short_desc: hotel?.area?.short_desc,
                },
                region: {
                    id: hotel?.region?.id,
                    name: hotel?.region?.name,
                    slug: hotel?.region?.slug,
                },
                country: {
                    id: hotel?.region?.country?.id,
                    name: hotel?.region?.country?.name,
                    slug: hotel?.region?.country?.slug,
                },
            };
        });
    return error;
};
exports.getPublishedHotelsByRegionId = getPublishedHotelsByRegionId;
const getHotelsByRegionId = async (supabase, region_id) => {
    const { data: hotels, error } = await supabase
        .from("hotels")
        .select(`id, name, published, star_rating, summary, slug, packages, images, transfer_area_id, policies,
      area:areas!area_id(*),
      transfer_area:areas!transfer_area_id(*),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
      contracts:hotel_contracts(*, 
        supplier:supplier_id (id, name, currency), products:hotel_contract_products(*, rates:hotel_contract_product_rates(*))),
      hotel_rooms(*)`)
        .eq("region_id", region_id)
        .order("name->en", { ascending: true });
    if (!error)
        return hotels.map((hotel) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(hotel.contracts, (c) => {
                return c.end_date;
            });
            return {
                id: hotel.id,
                rooms: hotel.hotel_rooms,
                summary: hotel.summary,
                name: hotel.name,
                policies: hotel.policies,
                images: JSON.parse(hotel.images),
                packages: hotel.packages,
                contracts: hotel.contracts,
                contract_expiry_date: latestContract?.end_date,
                star_rating: hotel.star_rating,
                published: hotel.published,
                slug: hotel.slug,
                transfer_area: {
                    id: hotel?.transfer_area?.id,
                    name: hotel?.transfer_area?.name,
                },
                area: {
                    id: hotel?.area?.id,
                    name: hotel?.area?.name,
                },
                region: {
                    id: hotel?.region?.id,
                    name: hotel?.region?.name,
                    slug: hotel?.region?.slug,
                },
                country: {
                    id: hotel?.region?.country?.id,
                    name: hotel?.region?.country?.name,
                    slug: hotel?.region?.country?.slug,
                },
            };
        });
    return error;
};
exports.getHotelsByRegionId = getHotelsByRegionId;
const addHotel = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        obj.modified_by = user?.id;
        obj.created_by = user?.id;
    }
    const { data, error } = await supabase
        .from("hotels")
        .insert([obj])
        .select()
        .single();
    //Create an area for the course
    await supabase.from("areas").insert([
        {
            id: data.id,
            name: obj.name,
            region_id: obj.region_id,
            longitude: obj.longitude,
            latitude: obj.latitude,
            created_at: obj.created_at,
            modified_at: obj.modified_at,
            created_by: obj.created_by,
            modified_by: obj.modified_by,
            type: "Hotel",
        },
    ]);
    if (!error)
        return data;
    return error;
};
exports.addHotel = addHotel;
const getHotel = async (supabase, id) => {
    const { data: hotel, error } = await supabase
        .from("hotels")
        .select(`*,  
      area:areas!area_id(*),
      transfer_area:areas!transfer_area_id(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .eq("id", id)
        .single();
    if (!error)
        return {
            ...hotel,
            transfer_area: {
                id: hotel?.transfer_area?.id,
                name: hotel?.transfer_area?.name,
            },
            area: {
                id: hotel?.area?.id,
                name: hotel?.area?.name,
            },
            region: {
                id: hotel?.region?.id,
                name: hotel?.region?.name,
                slug: hotel?.region?.slug,
            },
            country: {
                id: hotel?.region?.country?.id,
                name: hotel?.region?.country?.name,
                slug: hotel?.region?.country?.slug,
            },
        };
    return error;
};
exports.getHotel = getHotel;
const updateHotels = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data, error } = await supabase.from("hotels").upsert(updateObj);
    if (!error)
        return true;
    return false;
};
exports.updateHotels = updateHotels;
const updateHotel = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("hotels")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,  
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) )`)
        .single();
    // Update an area if it has changed
    await supabase
        .from("areas")
        .update({
        name: updateObj.name,
        longitude: updateObj.longitude,
        latitude: updateObj.latitude,
    })
        .eq("id", updateObj.id);
    if (!error)
        return data;
    return error;
};
exports.updateHotel = updateHotel;
const getContractComments = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotel_contract_notes")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("hotel_contract_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getContractComments = getContractComments;
const addContractComment = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id;
    obj.created_by = user?.id;
    const { data, error } = await supabase
        .from("hotel_contract_notes")
        .insert([obj])
        .single();
    if (!error)
        return data;
    return error;
};
exports.addContractComment = addContractComment;
const deleteContractComment = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotel_contract_notes")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContractComment = deleteContractComment;
const updateProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.hotel_room;
    const { data, error } = await supabase
        .from("hotel_contract_products")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProduct = updateProduct;
const addProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.hotel_room;
    const { data, error } = await supabase
        .from("hotel_contract_products")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addProduct = addProduct;
const deleteContract = async (supabase, id) => {
    await supabase
        .from("hotel_contract_notes")
        .delete()
        .eq("hotel_contract_id", id);
    const { data, error } = await supabase
        .from("hotel_contracts")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContract = deleteContract;
const deleteProduct = async (supabase, id) => {
    await supabase
        .from("hotel_contract_product_rates")
        .delete()
        .eq("contract_product_id", id);
    const { data, error } = await supabase
        .from("hotel_contract_products")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteProduct = deleteProduct;
const addRates = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("hotel_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addRates = addRates;
const deleteRate = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotel_contract_product_rates")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteRate = deleteRate;
const updateProductRates = async (supabase, rates) => {
    const obj = _.cloneDeep(rates);
    // in each rate delete the contract_id property
    obj.forEach((rate) => {
        if (rate.created_at === undefined)
            rate.created_at = new Date();
        delete rate.contract_id;
    });
    const { data, error } = await supabase
        .from("hotel_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProductRates = updateProductRates;
const getProductRateById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("hotel_contract_product_rates")
        .select("*")
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getProductRateById = getProductRateById;
const getHotelContracts = async (supabase, id) => {
    const { data: hotel_rooms, error: hotel_rooms_error } = await supabase
        .from("hotel_rooms")
        .select("*")
        .eq("hotel_id", id)
        .order("created_at", { ascending: true });
    const { data: hotel, error: hole_options_error } = await supabase
        .from("hotels")
        .select("id, name, supplier_id")
        .eq("id", id)
        .single();
    const { data: platforms, error: platforms_error } = await supabase
        .from("platforms")
        .select("*");
    const { data: contracts, error } = await supabase
        .from("hotel_contracts")
        .select(`*,       
      blackout_dates:hotel_contract_blackout_dates(*),
      hotel:hotel_id (id, name), 
      supplier:supplier_id (id, name, currency), 
      hotel_contract_notes(count),
      hotel_contract_products(
        *,
        hotel_room:hotel_rooms!hotel_room_id(id, name, max_occupancy, bed_options),
        hotel_contract_product_rates(
          *
        )
      )`)
        .eq("hotel_id", id);
    if (!error && !hotel_rooms_error && !platforms_error && !hole_options_error)
        return {
            hotel: {
                id: hotel.id,
                name: hotel.name,
                supplier_id: hotel.supplier_id,
            },
            hotel_rooms: hotel_rooms,
            platforms: platforms,
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    rate_code: contract.rate_code,
                    type: contract.type,
                    created_at: contract.created_at,
                    platforms: contract.platforms,
                    discounts: contract.discounts,
                    cancellation_policies: contract.cancellation_policies,
                    price_bands: contract.price_bands,
                    comments_count: contract.hotel_contract_notes[0].count,
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.hotel_contract_products
                        .sort((a, b) => dayjs(a.created_at).unix() - dayjs(b.created_at).unix())
                        .map((product) => ({
                        id: product.id,
                        contract_id: contract.id,
                        note: product.note,
                        hotel_room: product.hotel_room,
                        hotel_room_id: product.hotel_room_id,
                        board_options: product.board_options,
                        occupancy: product.occupancy,
                        availability_days: product.availability_days,
                        bed_option_id: product.bed_option_id,
                        created_at: product.created_at,
                        rates: product.hotel_contract_product_rates.map((rate) => ({
                            id: rate.id,
                            contract_id: contract.id,
                            price_band_id: rate.price_band_id,
                            contract_product_id: product.id,
                            cost_price: rate.cost_price,
                            margin: rate.margin,
                            min_nights: rate.min_nights,
                            book_before: rate.book_before,
                            sell_price: rate.sell_price,
                            created_at: rate.created_at,
                            discount_id: rate.discount_id,
                            non_refundable: rate.non_refundable,
                            cancellation_penalty_id: rate.cancellation_penalty_id,
                        })),
                    })),
                })),
        };
};
exports.getHotelContracts = getHotelContracts;
const addHotelContract = async (supabase, obj) => {
    const { data, error } = await supabase.from("hotel_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.addHotelContract = addHotelContract;
const updateHotelContract = async (supabase, contracts) => {
    const obj = _.cloneDeep(contracts);
    obj.forEach((contract) => {
        delete contract.products;
        delete contract.discounts;
        delete contract.cancellation_policies;
        delete contract.price_bands;
    });
    const { data, error } = await supabase.from("hotel_contracts").upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateHotelContract = updateHotelContract;
